import { Purchases } from "../constants/Purchases";

export const SingleProductDefault: any = {
  firstBill: {
    type: Purchases.FIRST_BILL,
    installments: 0,
  },
  cosmos: {
    type: Purchases.COSMOS,
    installments: 24,
  }
};
